import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ResourceCenter = () => {
  const resources = [
  {
    id: 1,
    type: 'guide',
    title: 'Руководство по быстрому старту',
    description: 'Пошаговая инструкция по настройке и запуску Jetu AI за 15 минут',
    image: "/images/resource_1.webp",
    imageAlt: 'Professional business person working on laptop with digital interface displaying AI automation dashboard and analytics graphs in modern office environment',
    icon: 'BookOpen',
    duration: '15 мин',
    category: 'Начало работы'
  },
  {
    id: 2,
    type: 'video',
    title: 'Видео-туры по платформе',
    description: 'Серия обучающих видео о всех возможностях Jetu AI',
    image: "/images/resource_2.webp",
    imageAlt: 'Modern video production setup with professional camera equipment filming educational content about AI technology in bright studio with blue and purple lighting',
    icon: 'Video',
    duration: '45 мин',
    category: 'Обучение'
  },
  {
    id: 3,
    type: 'documentation',
    title: 'Техническая документация',
    description: 'Полная документация API, SDK и интеграций для разработчиков',
    image: "/images/resource_3.webp",
    imageAlt: 'Software developer coding on multiple monitors showing API documentation, code editor with JavaScript, and technical diagrams in dark themed workspace',
    icon: 'Code',
    duration: 'Справочник',
    category: 'Разработка'
  },
  {
    id: 4,
    type: 'whitepaper',
    title: 'Автоматизация бизнеса с AI',
    description: 'Whitepaper о трансформации бизнес-процессов через AI-автоматизацию',
    image: "/images/resource_4.webp",
    imageAlt: 'Business analytics dashboard on laptop screen showing colorful charts, graphs, and AI performance metrics with coffee cup and notepad on wooden desk',
    icon: 'FileText',
    duration: '20 стр',
    category: 'Исследования'
  },
  {
    id: 5,
    type: 'template',
    title: 'Шаблоны автоматизации',
    description: 'Готовые сценарии для различных отраслей и бизнес-процессов',
    image: "/images/resource_5.webp",
    imageAlt: 'Business workflow templates and automation diagrams spread on desk with colorful sticky notes, flowcharts, and process documentation in organized layout',
    icon: 'Layout',
    duration: '50+ шаблонов',
    category: 'Ресурсы'
  },
  {
    id: 6,
    type: 'webinar',
    title: 'Еженедельные вебинары',
    description: 'Живые сессии с экспертами по внедрению и оптимизации AI',
    image: "/images/rocket_gen_img_1eb1caf23-1764426213439.webp",
    imageAlt: 'Professional online webinar presentation with speaker on video call screen, participants gallery, and presentation slides about AI technology in virtual meeting',
    icon: 'Users',
    duration: 'Каждую среду',
    category: 'События'
  }];


  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-foreground mb-4">
            Центр ресурсов и обучения
          </h2>
          <p className="text-lg text-muted-foreground">
            Получите доступ к обучающим материалам, документации и шаблонам для успешного использования Jetu AI
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {resources?.map((resource) =>
          <div
            key={resource?.id}
            className="bg-card border border-border rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">

              <div className="relative h-48 overflow-hidden">
                <Image
                src={resource?.image}
                alt={resource?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                  <span className="px-3 py-1 bg-accent text-accent-foreground text-xs font-medium rounded-full">
                    {resource?.category}
                  </span>
                  <div className="flex items-center space-x-1 text-white text-sm">
                    <Icon name="Clock" size={16} />
                    <span>{resource?.duration}</span>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
                    <Icon name={resource?.icon} size={20} color="var(--color-accent)" />
                  </div>
                  <h3 className="text-xl font-headline font-semibold text-foreground">
                    {resource?.title}
                  </h3>
                </div>

                <p className="text-muted-foreground text-sm leading-relaxed">
                  {resource?.description}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default ResourceCenter;